import React from "react";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { commonStyles } from "../../Services/ReactPDFService.jsx";

// Modern Cover Letter Template - Enhanced Professional Design with Blue Accents
const styles = StyleSheet.create({
  ...commonStyles,
  page: {
    ...commonStyles.page,
    fontFamily: "Roboto",
    backgroundColor: "#f8fafc",
    padding: 0,
  },
  // Left sidebar with blue stripe
  sidebar: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 6,
    backgroundColor: "#2563eb",
  },
  // Top corner accent
  topCornerAccent: {
    position: "absolute",
    right: 0,
    top: 0,
    width: 150,
    height: 150,
    backgroundColor: "#dbeafe",
    borderBottomLeftRadius: 100,
  },
  contentWrapper: {
    backgroundColor: "#ffffff",
    margin: "25 15 25 21",
    padding: "35 45",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOpacity: 0.08,
    shadowRadius: 12,
    shadowOffset: { width: 0, height: 4 },
  },
  headerContainer: {
    marginBottom: 35,
    paddingBottom: 25,
    borderBottomWidth: 2,
    borderBottomColor: "#e5e7eb",
  },
  name: {
    fontSize: 26,
    fontWeight: 700,
    color: "#1e40af",
    marginBottom: 8,
    letterSpacing: 0.5,
  },
  accentLine: {
    width: 70,
    height: 4,
    backgroundColor: "#2563eb",
    marginTop: 6,
    marginBottom: 14,
  },
  contactRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
  },
  contactDot: {
    width: 4,
    height: 4,
    backgroundColor: "#2563eb",
    borderRadius: 2,
    marginRight: 8,
  },
  contactInfo: {
    fontSize: 11,
    color: "#64748b",
    letterSpacing: 0.2,
  },
  bodyText: {
    fontSize: 11,
    lineHeight: 1.8,
    color: "#334155",
    marginBottom: 12,
    textAlign: "justify",
  },
});

const ModernCoverLetter = ({ coverLetterData }) => {
  const { header, generatedContent } = coverLetterData || {};
  const { name, email, phone, location } = header || {};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Decorative Elements */}
        <View style={styles.sidebar} />
        <View style={styles.topCornerAccent} />

        {/* Main Content Card */}
        <View style={styles.contentWrapper}>
          {/* Header with Modern Design */}
          <View style={styles.headerContainer}>
            <Text style={styles.name}>{name || "[Name]"}</Text>
            <View style={styles.accentLine} />

            <View style={styles.contactRow}>
              <View style={styles.contactDot} />
              <Text style={styles.contactInfo}>{email || "[Email]"}</Text>
            </View>

            <View style={styles.contactRow}>
              <View style={styles.contactDot} />
              <Text style={styles.contactInfo}>{phone || "[Phone]"}</Text>
            </View>

            <View style={styles.contactRow}>
              <View style={styles.contactDot} />
              <Text style={styles.contactInfo}>{location || "[Location]"}</Text>
            </View>
          </View>

          {/* Body Content */}
          <Text style={styles.bodyText}>{generatedContent || "No content generated yet."}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default ModernCoverLetter;
